import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../utils/api';
import * as storage from '../utils/storage';
import useAuthStore from '../stores/useAuthStore';

const KEY = ['areas'];

function normalize(a) { return { ...a, id: a.areaId || a.id }; }

export function useAreas() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: KEY,
    enabled: isAuthenticated,
    queryFn: async () => {
      const areas = await api.fetchAreas();
      const normalized = areas.map(normalize);
      storage.saveAreas(normalized);
      return normalized;
    },
    initialData: () => {
      const local = storage.loadAreas?.() || [];
      return local.length ? local.map(normalize) : undefined;
    },
  });
}

export function useCreateArea() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (area) => api.createArea(area),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateArea() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (area) => api.updateArea(area),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteArea() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.deleteArea(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
